export default "__VITE_ASSET__ByEFrIMN__"